import { Controller, useFormContext } from 'react-hook-form';

import KDSCheckbox, {
  type Props as KDSCheckboxProps,
} from '@decisiv/ui-components/lib/components/Checkbox';

interface CheckboxProps extends Omit<KDSCheckboxProps, 'defaultValue'> {
  name: string;
  defaultValue?: boolean;
  shouldUnregister?: boolean;
}

const Checkbox = ({
  name,
  defaultValue = false,
  shouldUnregister,
  ...props
}: CheckboxProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      shouldUnregister={shouldUnregister}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => {
        return (
          <KDSCheckbox
            checked={value}
            onChange={() => onChange(!value)}
            onClick={(e) => e.stopPropagation()}
            warningMessage={errors[name]?.message?.toString()}
            {...props}
          />
        );
      }}
    />
  );
};

export default Checkbox;
